<template>
  <q-dialog v-model="alert">
    <q-card class="text-center">
      <q-card-section>
        <div class="text-h6">{{clientName}}'s Card</div>
        <div class="text-subtitle2">{{clientName}}'s doesn't have enough points to collect a perk yet!</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <perks-card :cssclass="'row q-px-md q-gutter-md'" :perk="card" :points="card.points" :perks="place.pointsToPerk" :updatedAtAgo="card.updatedAtAgo" />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="OK" color="primary" @click="restartScanner()" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <div v-if="placeId" class="q-mb-xl">
    <div class="q-col-gutter-x-xs scan-header">
      <place-card :name="placeName" :id="placeId" :logo="logo" :actions="true" :pointsToPerk="place.pointsToPerk" />
    </div>
    <div class="scanner">
      <div v-if="loading">
        <p class="text-caption q-gutter-x-xs q-gutter-y-none">We need permission to access your camera for scan QR Codes</p>
        <p class="text-h6 q-gutter-x-xs q-gutter-y-none">Wait a few moments...</p>
        <Spinner />
      </div>
      <qrcode-stream :camera="camera" dense inline-actions :key="qrCount" @decode="onDecode" @init="onInit">
        <q-banner v-if="validationPending" rounded class="validation-pending bg-orange text-white">
          <Spinner color="white" /> Validation in progress...
        </q-banner>
      </qrcode-stream>

      <q-btn round color="primary" dense class="q-ma-sm" padding="xs xs" @click="restartScanner()" icon="refresh" />
    </div>
    <div class="q-pa-sm" v-if="error" >
      <q-banner round class="text-white bg-red">
        <template v-slot:avatar>
          <q-icon name="error" color="white" />
        </template>
        {{error}}
        <template v-slot:action>
        <q-btn flat label="Dismiss" @click="error = ''; restartScanner();" />
      </template>
      </q-banner>
    </div>
    <div class="q-pa-sm" v-if="suspended" >
      <q-banner round class="text-white bg-amber-14">
        <template v-slot:avatar>
          <q-icon name="error" color="white" />
        </template>
        Your plan has been suspended, either by your own request or by payment failure. You won't be able to make any scans until your plan has been activated again.
      </q-banner>
    </div>
    <div class="q-pa-sm" v-if="permission">
      <q-banner round dense class="bg-info text-white">
        <template v-slot:avatar>
          <q-icon name="info" color="white" />
        </template>

        You can grant permission at any time by just going in to the address bar of your browser and click on the camera icon.

      <template v-slot:action>
        <q-btn flat label="Dismiss" @click="permission = false" />
      </template>
      </q-banner>
    </div>
    <q-card flat class="fit wrap justify-center items-center content-center disable-doubleclick">
      <q-card-section vertical>
        <div class="text-subtitle2">Points to credit</div>
        <q-card-actions horizontal class="justify-center q-gutter-lg">
          <q-btn round color="accent" size="md" :disable="perksQty === 0" @click="perksQty = perksQty - 1" icon="remove" />
          <q-avatar color="primary" v-if="perksQty > 0" text-color="white">{{perksQty}}</q-avatar>
          <q-avatar color="primary" v-else text-color="white"><q-icon size="xl" name="img:/assets/icons/readonly.svg"></q-icon></q-avatar>
          <q-btn round color="accent" size="md" :disable="perksQty === 9" @click="perksQty = perksQty + 1" icon="add" />
        </q-card-actions>
        <div class="text-center text-caption" v-if="perksQty === 0">Read only</div>
      </q-card-section>
    </q-card>
    <q-card class="q-mx-xl q-mb-md bg-grey-1" v-if="!showHowTo">
      <q-card-section horizontal>
        <q-space />
        <q-btn @click="howTo()" dense rounded color="accent" size="xs" dark icon="close" v-close-popup>
            <q-tooltip class="bg-white text-primary">Close</q-tooltip>
        </q-btn>
      </q-card-section>
      <q-card-section class="q-py-none">
        <q-icon size="md" name="img:/assets/icons/i.svg" />
        <div class="text-h6 text-center">How it works</div>
        <div>
          <div class="text-left">1. Select how many points you want to give to your customer</div>
          <div class="text-left">2. Scan your customer's QrCode</div>
          <div class="text-left">3. The points are credited immediately after the code is validated</div>
          <q-btn size="md" color="primary" primary @click="howTo()" class="justify-center q-my-sm">Dismiss</q-btn>
        </div>
      </q-card-section>
    </q-card>
    <q-dialog v-model="validationSuccess">
      <q-card class="bg-secondary text-white q-px-none q-mx-none" style="width: 800px; max-width: 80vw;">
        <q-card-section horizontal>
          <q-space />
          <q-circular-progress
            :key="percentage"
            show-value
            :value="percentage"
            size="md"
            :thickness="0.2"
            color="primary"
            center-color="accent"
            track-color="transparent"
            class="text-primary"
          >
            <q-icon size="xs" name="close" @click="restartScanner()"  />
          </q-circular-progress>
        </q-card-section>
        <q-card-section horizontal class="q-py-none justify-center q-gutter-x-sm">
          <q-icon size="md" name="img:/assets/icons/success.svg" />
          <div class="text-h6 text-center">Success!</div>
        </q-card-section>
        <q-card-section>
          <p>{{message}}</p>
          <div class="row q-gutter-x-xs">
            <div class="col">
              <q-icon color="primary" size="xs" name="img:/assets/icons/history-icon-pink.svg" />
              Visited {{((card && card.visits) ? card.visits : 0) + 1}} times
            </div>
            <div class="col">
              <q-icon name="img:/assets/icons/points-duo-color.svg" />
              {{pointsToGo}} points to go
            </div>
          </div>
          <div class="text-center q-my-sm">
            <q-btn size="md" color="primary" primary @click="restartScanner()" >Dismiss</q-btn>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-card class="q-ma-sm" v-if="scansleft <= 10">
      <q-card-section horizontal>
        <q-space />
        <q-btn dense flat icon="close" />
      </q-card-section>
      <q-card-section>
        <div class="text-h6 text-center">Upgrade your account</div>
      </q-card-section>
      <q-card-section v-if="scansleft > 0">
        You're have only {{scansleft}} scans left this month. Upgrade your account now to continue scanning.
      </q-card-section>
      <q-card-section v-else>
        You have no scans left this month. Upgrade your account now to continue scanning.
      </q-card-section>
      <q-card-section>
        <q-space />
        <q-btn size="md" href="/merchant/plan">Upgrade</q-btn>
      </q-card-section>
    </q-card>
    <div class="justify-center q-mx-xl q-px-xl">
      <q-separator inset size="2px"></q-separator>
    </div>
    <div class="q-ma-md">
      <points-history title="Recent Activity" :rows="rows" :merchant="true"
      :pagination="pagination" @paginate="paginate" />
    </div>
    <collect-dialog v-if="card" :dialog="dialog" :actualPoints="card.points" :perksQty="perksQty"
    :totalPoints="totalPoints" :scanning="scanning" :points="points" :customer="clientName" 
    @save-points="savePoints" @cancel="cancel()" />
  </div>
</template>

<script>
import PerksCard from "@/components/PerksCard"
import {QrcodeStream} from "vue3-qrcode-reader";
import router from "@/router";
import {inject, ref, computed, watch} from "vue";
import Spinner from "@/components/Spinner";
import PlaceCard from "@/components/PlaceCard";
import { useStore } from 'vuex';
import PointsHistory from '@/components/PointsHistory';
import CollectDialog from '@/components/CollectDialog';
import VueCookies from 'vue-cookies'

export default {
  components: { QrcodeStream, Spinner, PlaceCard, PointsHistory, CollectDialog, PerksCard },

  setup() {
    const axios = inject('axios')
    const store = useStore()
    const uid = ref(false)
    const place = ref(false)
    const alert = ref(false)
    const placeName = ref('')
    const logo = ref('')
    const placeId = ref(null)
    const error = ref('')
    const perks = ref(null) //points needed to collect a perk
   // const scansleft = ref(null)
    const suspended = ref(false)
    const isValid =  ref(undefined)
    const camera = ref('auto')
    const result = ref(null)
    const perksQty = ref(1) //qtd of points being added
    const edit = ref(false)
    const points = ref(0)
    const dialog = ref(false)
    const loading = ref(false)
    const permission = ref(false)
    const qrCount = ref(0)
    const client = ref(null)
    const clientName = ref(null)
    const rows = ref([])
    const date = ref(null)
    const time = ref(null)
    const scansleft = ref(null)
    const scanning = ref(false)
    const page = ref(1)
    const pagination = ref({
      sortBy: 'desc',
      descending: false,
      page: 1,
      rowsPerPage: 5,
      rowsNumber: 0
    })
    const showHowTo = ref(VueCookies.get('howTo'))
    const totalPoints = ref(0)
    const card = ref(null)
    const percentage = ref(0)
    const closingWindow = ref(false)
    const message = ref(null)
    const collected = ref(false)
    const timer = ref(null)

    const validationPending = computed(() => {
      return isValid.value === undefined
        && camera.value === 'off'
    })

    const validationSuccess = computed(() => {
      return isValid.value === true
    })

    const validationFailure = computed(() => {
      return isValid.value === false
    })

    const pointsToGo = computed(() => {
      if(collected.value && ((place.value.pointsToPerk) - totalPoints.value) <= 1) return place.value.pointsToPerk
      else if (((place.value.pointsToPerk) - totalPoints.value) > 0) return place.value.pointsToPerk - totalPoints.value
      return 0
    })

    watch(isValid, () => { 
      // watch the isValid prop and count 5s everything the value is different of undefined, resetting success or validation messages
      if (isValid.value !== undefined) {
        closingWindow.value = true
        let current = 0
        timer.value = setInterval(() => {
          current += 1000;
          percentage.value = (current / 5000 ) * 100
          if (current === 5000) {
            clearInterval(timer);
            closingWindow.value = true
            percentage.value = 0
            collected.value = false
            restartScanner()
          }
        }, 5000);
      } else {
        clearInterval(timer.value);
        timer.value = null
        perksQty.value = 1
        percentage.value = 0
        collected.value = false
      }
    })

    const placeResponse = async () => {
      axios.get(`${process.env.VUE_APP_URL}/places?page=1&owner=${uid.value}`)
        .then(resp => {
          if (resp.data.length > 0) {
            const placeAux = resp.data[0]
            placeName.value = placeAux.name
            logo.value = placeAux.logo
            perks.value = placeAux.pointsToPerk
            place.value = placeAux
            placeId.value = placeAux.id
            scansleft.value = placeAux.scansLeft

            store.commit('setPlace', placeAux)

            store.commit('setScansLeft', placeAux.scansLeft)

            placeHistory()

          } else {
            // alert.value = true
            router.push('/merchant')
          }
        })
        .catch(err => {
          error.value = 'An error ocurred when getting points history. Wait a few moments and try again.'
        })
        .finally(() => loading.value = false)
    }

    const onInit = async (promise) => {
      try {
        loading.value = true
        const { capabilities } = await promise
        // successfully initialized
        resetValidationState()
      } catch (err) {

        loading.value = false
        if (err.name === 'NotAllowedError') {
          // user denied camera access permisson
          error.value = 'We need permission to access your camera to scan QR Codes.'
          permission.value = true
        } else if (err.name === 'NotFoundError') {
          // no suitable camera device installed
          error.value = 'You need a camera to use this feature.'
        } else if (err.name === 'NotSupportedError') {
          // page is not served over HTTPS (or localhost)
          error.value = 'You need a secure connection to use this feature.'
        } else if (err.name === 'NotReadableError') {
          // maybe camera is already in use
          error.value = 'Your camera is already in use.'
        } else if (err.name === 'OverconstrainedError') {
          // did you requested the front camera although there is none?
          error.value = 'Your browser doesn\'t support this feature.'
        } else if (err.name === 'StreamApiNotSupportedError') {
          // browser seems to be lacking features
          error.value = 'Your browser doesn\'t support this feature.'
        } else {
          error.value = 'An error has ocurred! Wait a few moments and try again'
        }
      } finally {
        // hide loading indicator
        loading.value = false
      }
    }

    const resetValidationState = () => {
      isValid.value = undefined
      error.value = null
    }

    const onDecode = async (content) => {
      if(!content){
        // isValid.value = false
        // error.value = "Invalid QR Code. The QR Code read is not a QR Perk"
        await timeout(4000)
        restartScanner()
        return
      }
      // result.value = decodeURIComponent(content)
      client.value = content.split('|')[0]
      clientName.value = content.split('|')[1]
      turnCameraOff()

      // pretend it's taking really long
      // await timeout(3000)

      if (scansleft.value > 0) {
        axios.get(`${process.env.VUE_APP_URL}/cards?page=1&owner=${client.value}&place=${placeId.value}&order%5BupdatedAt%5D=desc`)
          .then(resp => {
            totalPoints.value = perksQty.value
            if (resp.data.length > 0) {
              card.value = resp.data[0]
              totalPoints.value += card.value.points
              if ((perks.value && totalPoints.value > perks.value) || (perks.value && totalPoints.value >= perks.value && perksQty.value === 0)) {
                points.value = totalPoints.value - perks.value
                dialog.value = true
              } else {
                savePoints(false)
                points.value = perks.value - card.value.points
              }
            } else {
              savePoints(false)
              points.value = perks.value
            }
          })
          .catch(err => {
            loading.value = false
            isValid.value = false
            error.value = err.message
            if (err.response) error.value = err.response.data.title + ': ' + err.response.data.detail
          })
      } else {
        error.value = "You have no scans left! Upgrade or choose a plan to earn more scans."
        isValid.value = false
        await timeout(4000)
        restartScanner()
        return
      }
    }

    const paginate = (page) => {
      pagination.value.page = page
      placeHistory()
    }

    const placeHistory = () => {
      axios.get(`${process.env.VUE_APP_URL}/points?page=${pagination.value.page}&itemsPerPage=5&place=${placeId.value}&order%5BcreatedAt%5D=desc`,
      {
        headers: {
          'Content-Type': 'application/ld+json',
          'Accept': 'application/ld+json',
        }
      })
        .then(resp => {
          let points = resp.data["hydra:member"].map(e => {
            return {
              ...e,
              createdAt: new Date(e.createdAt).toLocaleString(),
              message: ((e.isPerk) ? 'Perk collected by ' : (e.points > 1) ? e.points + ' points given to ' : e.points + ' point given to ') + (e.user.name ?? 'Anonymous')
            }
          })
          pagination.value.rowsNumber = Math.ceil(resp.data['hydra:totalItems'] / 5)
          rows.value = points
        })
        .catch(err => {
          loading.value = false
          error.value = err.message
        })
    }

    const savePoints = async (isPerk) => {
      scanning.value = true
      
      if (perksQty.value === 0 && !isPerk) { // verify if is readonly
        alert.value = true
        return
      }

      store.dispatch('verifyLogged')
      .then(async resp => {
        try {
          let data
          if ((isPerk && (perksQty.value > 1)) || (perksQty.value > 0 && !isPerk)) { // verify if has to insert points and insert them
            data = {
              points: (isPerk) ? (perksQty.value - 1) : perksQty.value,
              qrcode: client.value,
              place: '/places/' + placeId.value,
              isPerk: false,
            }
            await axios.post(`${process.env.VUE_APP_URL}/points`, data)
            message.value = `You've just added ${perksQty.value} points to ${clientName.value}.`
          }

          if (isPerk) { // verify if it is collection and collect
            data = {
              points: -Math.abs(perks.value),
              qrcode: client.value,
              place: '/places/' + placeId.value,
              isPerk: true,
            }
            await axios.post(`${process.env.VUE_APP_URL}/points`, data)
            collected.value = true
            message.value = `You've just collected a perk to ${clientName.value}.`
          }

          isValid.value = true
          dialog.value = false
          scansleft.value = scansleft.value - 1
          scanning.value = false
          placeHistory()

        } catch(err) {
          error.value = err.message
          scanning.value = false
          isValid.value = false
          collected.value = false
        }
      })
      .catch(err => {
        error.value = err.message
        store.commit('setUser', null)
        store.commit('setClearHistory')
        store.commit('clearPlace')
        router.push('/')
      })
      
    }

    const turnCameraOn = () => {
      camera.value = 'auto'
    }

    const turnCameraOff = () => {
      camera.value = 'off'
    }

    const timeout = (ms) => {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    }

    const restartScanner = () => {
      scanning.value = true
      resetValidationState()
      turnCameraOn()
      qrCount.value = qrCount.value + 1
      scanning.value = false
    }

    const howTo = () => {
      VueCookies.set('howTo', true, Infinity)
      showHowTo.value = true
    }

    const cancel = () => {
      dialog.value = false
      restartScanner()
    }

    store.dispatch('verifyLogged')
    .then(resp => {
      if (store.getters.isAnonymous) router.push('/user/signin')
      uid.value = store.getters.stateUser.id

      placeResponse()
    })
    .catch(error => {
      store.commit('setUser', null)
      store.commit('setClearHistory')
      store.commit('clearPlace')
      router.push('/')
    })
  
    return {placeName, place, placeId, uid, logo, alert, perks, error, suspended, scansleft, scanning, time, date, rows, page,
      client, clientName, permission, qrCount, message, loading, dialog, points, edit, perksQty, result, camera, isValid,
      validationPending, validationSuccess, validationFailure,
      restartScanner, timeout, turnCameraOff, turnCameraOn, savePoints, onDecode, resetValidationState, onInit,
      pagination, paginate, showHowTo, howTo, totalPoints, card, pointsToGo, closingWindow, percentage, cancel
    }
  },
}
</script>

<style scoped>
@media only screen and (orientation:landscape) and (hover: none) and (pointer: coarse) {
  .scan-header { display:none; }
  .scanner {
    max-width: 300px;
    margin: 0 auto;
    padding-bottom: 10px;
  }
}
 
/* Show place when portrait */
@media only screen and (orientation:portrait) and (hover: none) and (pointer: coarse) {
  .scan-header { display:block; }
}
.validation-success,
.validation-failure,
.validation-pending {
  position: absolute;
  width: 100%;

  background-color: rgba(255, 255, 255, .8);
  text-align: center;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.validation-success {
  color: green;
}
.validation-failure {
  color: red;
}
.scanner {
  width: 70%;
  margin: 0 auto;
}

.disable-doubleclick {
  touch-action: manipulation;
}
</style>
